import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

import Text from '../../../designSystem/Text';
import Icon from '../../../designSystem/Icon';

import styles from './HelpDeskLateral.module.scss';

import { breakPointMd } from '../../../utils/constants';

type HelpDeskLateralOptionT = {
  id: string;
  title: string;
  onClick: () => void;
};

type HelpDeskLateralT = {
  title: string;
  selectedId: string;
  options: HelpDeskLateralOptionT[];
};

const HelpDeskLateral = ({ title, selectedId, options }: HelpDeskLateralT) => {
  const [isOptionOpen, setIsOptionOpen] = useState<boolean>(false);

  const optionClassnames = (id: string) =>
    classnames(styles.help_desk_lateral_option_item, {
      [styles.selected]: id === selectedId,
    });

  const icon = isOptionOpen ? 'expand_less' : 'expand_more';

  const onToggleQuestionsHandler = () => setIsOptionOpen(!isOptionOpen);

  useEffect(() => {
    const onResizeWindow = () => setIsOptionOpen(window.innerWidth > breakPointMd);

    window.addEventListener('resize', onResizeWindow);
    onResizeWindow();

    return () => {
      window.removeEventListener('resize', onResizeWindow);
    };
  }, []);

  return (
    <div className={styles.help_desk_lateral}>
      <div
        className={styles.help_desk_lateral_category_container_mobile}
        onClick={onToggleQuestionsHandler}
        onKeyPress={onToggleQuestionsHandler}
        role="button"
        tabIndex={0}
      >
        <Text text={title} customClass={styles.help_desk_lateral_category} />
        <Icon name={icon} customClass={styles.help_desk_lateral_icon} size="medium" />
      </div>

      <div className={styles.help_desk_lateral_category_container}>
        <Text text={title} customClass={styles.help_desk_lateral_category} />
      </div>

      {isOptionOpen && (
        <div className={styles.help_desk_lateral_options}>
          {options.map((option: HelpDeskLateralOptionT, index: number) => (
            <div
              key={`help_desk_lateral_${index}`}
              className={optionClassnames(option.id)}
              onClick={option.onClick}
              onKeyPress={option.onClick}
              role="button"
              tabIndex={0}
            >
              {option.title}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default HelpDeskLateral;
